import React from "react";

const Section = ({ id, label, value, onToggle, onText, icon }) => (
  <div className="exam-row">
    <label>
      <span style={{ marginRight: 8 }}>{icon}</span>
      <input 
        type="checkbox" 
        checked={value.on === 1} 
        onChange={(e) => onToggle(id, e.target.checked ? 1 : 0)} 
      />
      {" "}{label}
    </label>
    <textarea 
      rows={2} 
      value={value.text || ""} 
      onChange={(e) => onText(id, e.target.value)} 
      placeholder="Finding..." 
    />
  </div>
);

export default function ExamForm({ exam, onChange }) {
  const toggle = (k, v) => onChange({ ...exam, [k]: { ...exam[k], on: v } });
  const setTxt = (k, v) => onChange({ ...exam, [k]: { ...exam[k], text: v } });

  // Mapeo de iconos para cada sección del examen físico
  const sectionIcons = {
    GeneralAppearance: "🙂",
    EyesBL: "👀",
    Ears: "👂",
    Nose: "👃",
    OralCavity: "👄",
    Throat: "🗣️",
    NeckThyroid: "🧈",
    Heart: "❤️",
    Lungs: "🫁",
    Abdomen: "🫀",
    back: "🧍",
    Musculoskeletal: "🦴",
    Skin: "🧴",
    Neurologic: "🧠",
    Extremities: "🦵",
    Psychiatric: "🧠"
  };

  // Etiquetas más legibles para las secciones
  const sectionLabels = {
    GeneralAppearance: "General",
    EyesBL: "Eyes",
    Ears: "Ears",
    Nose: "Nose",
    OralCavity: "Oral Cavity",
    Throat: "Throat",
    NeckThyroid: "Neck/Thyroid",
    Heart: "Heart",
    Lungs: "Lungs",
    Abdomen: "Abdomen",
    back: "Back",
    Musculoskeletal: "Musculoskeletal",
    Skin: "Skin",
    Neurologic: "Neurologic",
    Extremities: "Extremities",
    Psychiatric: "Psychiatric"
  };

  return (
    <div className="cn-card">
      <h3>🩺 Physical Examination</h3>
      {Object.entries(exam).map(([id, val]) => (
        <Section
          key={id}
          id={id}
          label={sectionLabels[id] || id}
          value={val}
          onToggle={toggle}
          onText={setTxt}
          icon={sectionIcons[id] || "📋"}
        />
      ))}
    </div>
  );
}